<script lang="ts" context="module">
  import {writable} from 'svelte/store';
  export interface MenuComponentOpt {
    args?: any;
    component: any;
  }
  export const extendedOptionStore = writable<{
    target?: HTMLElement | Element | null | boolean;
    components: MenuComponentOpt[];
  }>({
    target: null,
    components: []
  });

  export const closeExtendedMenu = () => {
    extendedOptionStore.set({
      target: null,
      components: []
    });
  };

  export const openExtendedMenu = (components: MenuComponentOpt[]) => {
    extendedOptionStore.set({
      target: true,
      components
    });
  };
</script>

<script lang="ts">
  import {horizontalSlide} from '../../transitions/transitions';
  import {onDestroy} from 'svelte';
  let m: HTMLElement | null = null;
  const closeExtendedMenuOnNotTargetSelect = (e: MouseEvent) => {
    if (m) {
      // if(e.target.contains(e.target)) return;
      if (m.contains(e.target)) return;
      closeExtendedMenu();
    }
  };

  const unmount = extendedOptionStore.subscribe(store => {
    if (store.target) {
      document.addEventListener('click', closeExtendedMenuOnNotTargetSelect);
    } else {
      document.removeEventListener('click', closeExtendedMenuOnNotTargetSelect);
    }
  });

  onDestroy(unmount);
</script>

{#if $extendedOptionStore.target}
  <div
    bind:this={m}
    in:horizontalSlide
    out:horizontalSlide
    class="absolute left-0 h-full w-72 bg-white p-2"
    style="z-index: 1000;"
  >
    {#each $extendedOptionStore.components as component}
      <svelte:component this={component.component} {...component.args} />
    {/each}
  </div>
{/if}
